import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import CreateReactClass from 'create-react-class';
import GrowthGoalsUtils from '../utils';

export default CreateReactClass({
    displayName: 'action-plan-modal',

    getInitialState() {
        return {
            show: false,
        };
    },

    promise: null,
    resolve: null,
    reject: null,
    actionPlan: null,
    growthGoalBid: null,

    show(actionPlan, growthGoalBid) {
        this.setState({
            show: true,
        });
        this.actionPlan = actionPlan;
        this.growthGoalBid = growthGoalBid;

        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });

        //Catch errors thrown within the promise here
        this.promise.catch((e) => {
            //Squash undefined errors
            if (typeof e != 'undefined') {
                console.log(e.message);
                console.log(e.stack);
            }
        });

        return this.promise;
    },

    onClose() {
        this.reject();
        this.setState({ show: false });
    },

    renderButton() {
        return [
            <Button
                key="close-button"
                id={`action-plan-modal-close-button-${this.growthGoalBid}`}
                bsClass="cancel-button btn"
                onClick={this.onClose}
            >
                CLOSE
            </Button>,
        ];
    },

    render() {
        const content = GrowthGoalsUtils.safeDecodeUri(this.actionPlan);
        const buttons = this.renderButton();

        return (
            <Modal
                id={`action-plan-modal-${this.growthGoalBid}`}
                bsSize="lg"
                aria-labelledby="action-plan-modal"
                onHide={this.onClose}
                bsClass="growth-goal-modal modal"
                show={this.state.show}
            >
                <Modal.Header key="header" closeButton={true}>
                    <Modal.Title>ACTION PLAN</Modal.Title>
                </Modal.Header>
                <Modal.Body key="body" bsClass="modal-body growth-goal display-linebreak">
                    {content}
                </Modal.Body>
                <Modal.Footer>{buttons}</Modal.Footer>
            </Modal>
        );
    },
});
